// @file Network requests related to surface settings from surface

import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import { HTTPMethod } from '@padlet/fetch'

const API_VERSION = 9

export interface SurfaceSettings {
  canInviteStudents: boolean
  isWallTransferable: boolean
  canAddClassToWall: boolean
}

class SurfaceSettingsApi extends FetchableObject {
  public static async fetch(wallId: number, fetchOptions: VersionedFetchOptions = {}): Promise<SurfaceSettings> {
    const { apiVersion = API_VERSION, ...otherFetchOptions } = fetchOptions
    const surfaceSettingsPath = `/api/${apiVersion}/surface-settings?wall_id=${wallId}`
    const response = await fetchJson(surfaceSettingsPath, {
      method: HTTPMethod.get,
      ...otherFetchOptions,
    })
    return response
  }
}

export { SurfaceSettingsApi }
